export default __webpack_public_path__ + "img/sagoo/kraftpaper.webp";